module.exports = __webpack_public_path__ + "static/media/NoCover.3da9a41e.png";